PJQ.collections.directcosts = PJQ.collections.directcosts ? PJQ.collections.directcosts : {};;
PJQ.models.directcosts = PJQ.models.directcosts ? PJQ.models.directcosts : {};
PJQ.views.directcosts = PJQ.views.directcosts ? PJQ.views.directcosts : {};

PJQ.modules.directcosts = {
    routes: [
        {
            route: 'projects/:projectId/directcosts',
            name: 'directcosts',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "directcosts");
            }
        },
        {
            route: 'projects/:projectId/directcosts/:directCostId',
            name: 'directcosts',
            callback: function (projectId, directCostId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "directcosts", {
                    directCostId: parseInt(directCostId)
                });
            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.directcosts.routes);

PJQ.views.directcosts.DirectCostDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'Click "Add Direct Cost" to create a new Direct Cost',
            zeroRecords: "No Direct Costs matched the search criteria"
        },
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.DIRECTCOSTS, 'data-table-header-direct-costs')
        },
        toggleRowClass: '.dc-toggle-row'
    },
    events: {},
    beforeDataTableRender: function () {
        this.options.pageLength = this.options.settings ? this.options.settings.rowsPerPage : 10;
    },
    getDefaultFilter: function () {
        let defaultFilter = {};
        defaultFilter[PJQ.constants.directcosts.filterType.DIRECT_COST_TYPE_FILTER] = this.options.userSettings.get('defaultTypeFilter');
        defaultFilter[PJQ.constants.directcosts.filterType.DIRECT_COST_TYPE_FILTER] = _.map(defaultFilter[PJQ.constants.directcosts.filterType.DIRECT_COST_TYPE_FILTER], function (type) {
            return type * -1;
        });
        defaultFilter[PJQ.constants.directcosts.filterType.DIRECT_COST_STATUS_FILTER] = _.size(this.options.statusIds) > 0 ? this.options.statusIds : this.options.userSettings.get('defaultStatusFilter');

        return defaultFilter;
    },
    getFilterValues: function () {
        let typeFilter = this.getFilter(PJQ.constants.directcosts.filterType.DIRECT_COST_TYPE_FILTER),
            statusFilter = this.getFilter(PJQ.constants.directcosts.filterType.DIRECT_COST_STATUS_FILTER);
        return {
            search: this.$('.datatable-search').val(),
            typeFilter: typeFilter.join(','),
            statusFilter: statusFilter.join(',')
        };
    },
    afterHeaderRender: function () {
        new PJQ.inputs.Selectpicker({
            el: this.$('.direct-cost-filter'),
            defaultValue: this.getDefaultFilter(),
            isGrouped: true,
            isIntChoices: true,
            isMultiple: true,
            noneSelectedText: 'No Filters',
            onChange: _.bind(function (value) {
                value.directCostStatusFilter = value.directCostStatusFilter ? value.directCostStatusFilter : [];
                value.directCostTypeFilter = value.directCostTypeFilter ? value.directCostTypeFilter : [];
                _.each(value, _.bind(function (value, filter) {
                    if (filter === PJQ.constants.directcosts.filterType.DIRECT_COST_TYPE_FILTER)
                        value = _.map(value, function (type) {
                            return type * -1;
                        });
                    this.setFilter(filter, value);
                }, this));
            }, this)
        });

        let defaultFilters = this.getDefaultFilter();
        this.setFilter(PJQ.constants.directcosts.filterType.DIRECT_COST_TYPE_FILTER, defaultFilters[PJQ.constants.directcosts.filterType.DIRECT_COST_TYPE_FILTER]);
        this.setFilter(PJQ.constants.directcosts.filterType.DIRECT_COST_STATUS_FILTER, defaultFilters[PJQ.constants.directcosts.filterType.DIRECT_COST_STATUS_FILTER]);
    },
    getFilterData: function () {
        let typeFilter = this.getFilter(PJQ.constants.directcosts.filterType.DIRECT_COST_TYPE_FILTER),
            statusFilter = this.getFilter(PJQ.constants.directcosts.filterType.DIRECT_COST_STATUS_FILTER),
            result = null, draft = 0, total = 0;
        if (_.size(typeFilter) === 0 && _.size(statusFilter) === 0) {
            result = this.options.data;
        } else {
            result = _.filter(this.options.data, function (row) {
                return (_.size(typeFilter) === 0 || _.contains(typeFilter, row.get('type'))) && (_.size(statusFilter) === 0 || _.contains(statusFilter, row.get('statusId')));
            });
        }

        _.each(result, function (directCost) {
            if (directCost.get('statusId') === PJQ.constants.directcosts.directCostStatus.DRAFT)
                draft += directCost.get('amount') ? directCost.get('amount') : 0;
            else
                total += directCost.get('amount') ? directCost.get('amount') : 0;
        });

        this.options.directCostView.renderTotals(draft, total);

        return result;
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns = ['createdOn', 'type', 'status', 'description', 'vendor.companyName', 'vendor.contactName', 'reportedBy.companyName', 'reportedBy.contactName', 'terms', 'appliedOn', 'receivedOn', 'paidOn', 'amount'];

        if (this.options.customFields) {
            _.each(this.options.customFields.models, _.bind(function (customField) {
                includeColumns.push('fieldValue' + customField.get('fieldNumber'));
            }, this));
        }

        if (!includeAllColumns) {
            if (_.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;

            columns.push({
                "columnData": "childData",
                "data": null,
                "title": "",
                "width": "20px",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": (data, type, row) => {
                    if(!this.options.isAdmin){
                        return "";
                    }

                    let exObj = row.get('externalObject');
                    if (exObj == null) {
                        return '';
                    }

                    return PJQ.helpers.erp.getERPBadge(exObj.status, exObj);
                }
            });
        }

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'createdOn':
                    columns.push({
                        "columnData": "createdOn",
                        "data": "attributes.createdOn",
                        "title": 'Created',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(row.get('createdOn')), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }, this)
                    });
                    break;
                case 'amount':
                    columns.push({
                        "columnData": "amount",
                        "data": "attributes.amount",
                        "width": "10%",
                        "title": "Amount",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                        }, this)
                    });
                    break;
                case 'type':
                    columns.push({
                        "columnData": "type",
                        "data": "attributes.type",
                        "title": "Type",
                        "width": "110px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.constants.directcosts.directCostTypeNames[row.get('type')]
                        }, this)
                    });
                    break;
                case 'status':
                    columns.push({
                        "columnData": "status",
                        "data": "attributes.statusId",
                        "title": "Status",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.constants.directcosts.directCostStatusNames[row.get('statusId')]
                        }, this)
                    });
                    break;
                case 'description':
                    columns.push({
                        "columnData": "description",
                        "data": "attributes.description",
                        "title": "Description"
                    });
                    break;
                case 'terms':
                    columns.push({
                        "columnData": "terms",
                        "data": "attributes.terms",
                        "title": "Terms"
                    });
                    break;
                case 'appliedOn':
                    columns.push({
                        "columnData": "appliedOn",
                        "data": "attributes.appliedOn",
                        "title": 'Applied',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return row.get('appliedOn') ? PJQ.helpers.dateHelpers.getDateString(new Date(row.get('appliedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE, true) : 'N/A';
                        }, this)
                    });
                    break;
                case 'receivedOn':
                    columns.push({
                        "columnData": "receivedOn",
                        "data": "attributes.receivedOn",
                        "title": 'Received',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return row.get('receivedOn') ? PJQ.helpers.dateHelpers.getDateString(new Date(row.get('receivedOn')), PJQ.helpers.dateHelpers.dateFormats.DATE, true) : 'N/A';
                        }, this)
                    });
                    break;
                case 'paidOn':
                    columns.push({
                        "columnData": "paidOn",
                        "data": "attributes.paidOn",
                        "title": 'Paid',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return row.get('paidOn') ? PJQ.helpers.dateHelpers.getDateString(new Date(row.get('paidOn')), PJQ.helpers.dateHelpers.dateFormats.DATE, true) : 'N/A';
                        }, this)
                    });
                    break;
                case 'vendor.companyName':
                    columns.push({
                        "columnData": "vendor.companyName",
                        "title": "Vendor",
                        "render": _.bind(function (data, type, row) {
                            return row.get('vendor') ? row.get('vendor').companyName : 'N/A';
                        }, this)
                    });
                    break;
                case 'vendor.contactName':
                    columns.push({
                        "columnData": "vendor.contactName",
                        "title": "Vendor Contact",
                        "render": _.bind(function (data, type, row) {
                            return row.get('vendor') ? row.get('vendor').contactName : 'N/A';
                        }, this)
                    });
                    break;
                case 'reportedBy.companyName':
                    columns.push({
                        "columnData": "reportedBy.companyName",
                        "title": "Reported by Company",
                        "render": _.bind(function (data, type, row) {
                            return row.get('reportedBy') ? row.get('reportedBy').companyName : 'N/A';
                        }, this)
                    });
                    break;
                case 'reportedBy.contactName':
                    columns.push({
                        "columnData": "reportedBy.contactName",
                        "title": "Reported by Contact",
                        "render": _.bind(function (data, type, row) {
                            return row.get('reportedBy') ? row.get('reportedBy').contactName : 'N/A';
                        }, this)
                    });
                    break;
                default:
                    if (columnName.startsWith('fieldValue')) {
                        _.each(this.options.customFields.models, function (customField) {
                            if (columnName === 'fieldValue' + customField.get('fieldNumber')) {
                                columns.push({
                                    "columnData": 'fieldValue' + customField.get('fieldNumber'),
                                    "title": customField.get('name'),
                                    "className": [PJQ.constants.commitments.customFieldType.INTEGER, PJQ.constants.commitments.customFieldType.MONEY, PJQ.constants.commitments.customFieldType.PERCENT].indexOf(customField.get('fieldTypeId')) !== -1 ? "text-align-right" : "",
                                    "render": function (data, type, row) {
                                        let fieldValue = row.getCustomFieldValue(customField.get('id'));
                                        fieldValue = (fieldValue !== null) ? fieldValue : '';
                                        switch (customField.get('fieldTypeId')) {
                                            case PJQ.constants.commitments.customFieldType.BOOLEAN:
                                                if (fieldValue != null)
                                                    fieldValue = fieldValue ? 'Yes' : 'No';
                                                break;
                                            case PJQ.constants.commitments.customFieldType.CHOICE:
                                                let choices = [];
                                                // convert single choice value into array so that the logic below can work for both types.
                                                if (typeof fieldValue === 'number')
                                                    fieldValue = [fieldValue];

                                                _.each(customField.choices.models, _.bind(function (choice) {
                                                    if (_.find(fieldValue, function (value) {
                                                        return value === choice.get('id');
                                                    }))
                                                        choices.push(choice.get('name'));
                                                }, this));

                                                fieldValue = choices.join((', '));
                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATE:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATETIME:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME, false);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.INTEGER:
                                                if (type !== 'sort' && type !== 'type' && fieldValue) {
                                                    fieldValue = parseInt(fieldValue).toLocaleString();
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.MONEY:
                                                if (type === 'sort' || type === 'type') {
                                                    if (fieldValue && fieldValue !== '$')
                                                        fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
                                                    else
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)));
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.PERCENT:
                                                if (type === 'sort' || type === 'type') {
                                                    if (!fieldValue)
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = fieldValue ? PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)), 2, false) + '%' : '';
                                                }
                                                break;
                                        }

                                        return fieldValue;
                                    }
                                });
                            }
                        });
                    }
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                "title": '',
                "render": _.bind(function (data, type, row) {
                    return '<div class="show-on-row-hover"><button type="button" class="btn btn-info btn-view-direct-cost ml-1" title="View direct cost"><i class="fal fa-arrow-alt-from-left"></i></button></div>';
                }, this),
                "orderable": false,
                "searchable": false,
                "width": "90px",
                "className": "text-center",
                "visible": true
            });
        }

        return columns;
    },
    getRowChildTable: function (childOpts) {
        childOpts.costTypes = this.options.costTypes;
        childOpts.unitsOfMeasure = this.options.unitsOfMeasure;
        childOpts.groups = this.options.groups;
        childOpts.parentDataTable = this;
        childOpts.dom = 't';
        return new PJQ.views.directcosts.DirectCostLineItemDataTable(childOpts);
    },
    getRowChildData: function (row) {
        return new PJQ.collections.directcosts.LineItems(null, {
            projectId: row.data().get('projectId'),
            directCostId: row.data().get('id')
        });
    }
});

PJQ.views.directcosts.DirectCostLineItemDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            zeroRecords: "No Line Items Added"
        },
        canEdit: false,
        onEditLineItem: _.noop,
        onDeleteLineItem: _.noop
    },
    getColumns: function (includeAllColumns = false) {
        let columns = [],
            includeColumns;
        if (this.options.parentData && this.options.parentData.get('accountingMethod') === PJQ.constants.budget.accountingMethod.AMOUNT)
            includeColumns = ['group', 'costTypeDescription', 'description', 'amount', 'billedToDate', 'amountRemaining'];
        else
            includeColumns = ['group', 'costTypeDescription', 'description', 'quantity', 'unitOfMeasure', 'unitPrice', 'amount', 'billedToDate', 'amountRemaining'];

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'description':
                    columns.push({
                        "columnData": "description",
                        "data": "attributes.description",
                        "orderable": false,
                        "title": "Description"

                    });
                    break;
                case 'quantity':
                    columns.push({
                        "columnData": "quantity",
                        "data": "attributes.quantity",
                        "orderable": false,
                        "width": "8%",
                        "title": "Units",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatDecimal(row.get('quantity'), 2);
                        }, this)
                    });
                    break;
                case 'unitOfMeasure':
                    columns.push({
                        "columnData": "unitOfMeasure",
                        "data": "attributes.unitId",
                        "orderable": false,
                        "title": "Unit",
                        "width": "5%",
                        "render": _.bind(function (data, type, row) {
                            let unitOfMeasure = this.options.unitsOfMeasure.get(row.get('unitId'));
                            return unitOfMeasure ? unitOfMeasure.get('code') : '';
                        }, this)
                    });
                    break;
                case 'unitPrice':
                    columns.push({
                        "columnData": "unitPrice",
                        "data": "attributes.unitPrice",
                        "orderable": false,
                        "width": "10%",
                        "title": "Unit Price",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('unitPrice'));
                        }, this)
                    });
                    break;
                case 'amount':
                    columns.push({
                        "columnData": "amount",
                        "data": "attributes.amount",
                        "orderable": false,
                        "width": "10%",
                        "title": "Amount",
                        "className": "text-align-right",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                        }, this)
                    });
                    break;
                case 'group':
                    columns.push({
                        "columnData": "group",
                        "orderable": false,
                        "title": "Cost Code",
                        "render": _.bind(function (data, type, row) {
                            let group = this.options.groups.get(row.get('groupId'));
                            return group ? group.get('groupName') : '';
                        }, this)
                    });
                    break;
                case 'costType':
                    columns.push({
                        "columnData": "costType",
                        "orderable": false,
                        "title": "Type Code",
                        "titleSettings": "Cost Type",
                        "width": "8%",
                        "render": _.bind(function (data, type, row) {
                            let costType = this.options.costTypes.get(row.get('costTypeId'));
                            return costType ? costType.get('code') : '';
                        }, this)
                    });
                    break;
                case 'costTypeDescription':
                    columns.push({
                        "columnData": "costTypeDescription",
                        "orderable": false,
                        "title": "Type",
                        "render": _.bind(function (data, type, row) {
                            let costType = this.options.costTypes.get(row.get('costTypeId'));
                            return costType ? costType.get('name') : '';
                        }, this)
                    });
                    break;
            }
        }, this));

        return columns;
    }
});

PJQ.views.directcosts.DirectCostEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DIRECTCOSTS, 'modal-direct-cost-edit'),
        width: '95%',
        maxWidth: 1500,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-save-email': 'saveEmail',
        'click .btn-save': 'saveDirectCost',
        'click .btn-push-erp': 'pushERP',
        'click .btn-undo-push-erp': 'undoPushERP',
        'click .btn-unlink-erp': 'unlinkERP',
        'click .btn-delete': 'deleteDirectCost',
        'click .btn-export': 'exportDirectCost',
        'click .btn-close': 'close',
        'click .btn-email': 'email',
        'click .nav-link': 'activeViewChanged'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.options.project = PJQ.app.session.project;
        this.options.isAdmin = PJQ.app.session.project.hasPermission('directCosts.isAdmin');

        this.coreFieldSettings = await PJQ.app.session.fetchDirectCostFieldSettings();
        this.settings = await PJQ.app.session.fetchDirectCostSettings();
        this.customFields = await this.options.project.fetchDirectCostCustomFields();
        this.costCodes = await this.options.project.fetchCostCodes();
        this.costTypes = await this.options.project.fetchCostTypes();
        this.unitsOfMeasure = await this.options.project.fetchUnitsOfMeasure();
        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
            await this.options.project.fetchERPObject();
        }

        if (this.model == null) {
            let customFieldValues = [];

            _.each(this.customFields.models, function (model, index) {
                let value = model.get('defaultValue') ? model.get('defaultValue') : '';
                if (model.get('fieldType') === 'CHOICE') {
                    value = parseInt(value);
                }
                customFieldValues.push({
                    fieldNumber: model.get('fieldNumber'),
                    fieldTypeId: model.get('fieldTypeId'),
                    fieldType: model.get('fieldType'),
                    isMultiple: model.get('isMultiple'),
                    value: value,
                    id: model.get('id')
                })
            }, this);

            this.model = new PJQ.models.directcosts.DirectCost({
                type: PJQ.constants.directcosts.directCostType.EXPENSE,
                description: '',
                terms: '',
                projectId: PJQ.app.session.project.id,
                statusId: PJQ.constants.directcosts.directCostStatus.DRAFT,
                accountingMethod: this.settings.get('defaultAccountingMethod'),
                customFieldValues: customFieldValues
            });
        }

        if (!this.model.isNew()) {
            await this.model.fetch();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.disabledStatuses = [];
        this.options.canEdit = this.options.project.hasPermission('directCosts.canEdit');
        this.options.canDelete = this.options.isAdmin;
        this.options.canEditStatus = this.options.isAdmin;
        if (this.model != null) {
            let status = this.model.get('statusId');
            if (status === PJQ.constants.directcosts.directCostStatus.DRAFT) {
                this.options.canEdit = true;
            } else if (status === PJQ.constants.directcosts.directCostStatus.APPROVED) {
                this.options.canDelete = false;
                this.options.canEdit = this.options.canEdit && this.model.isNew();
            } else {
                this.options.canEdit = PJQ.app.session.project.hasPermission('directCosts.canEdit');
            }

            if (this.erpIntegration != null) {
                let syncStatus = this.model.erpSyncStatus();
                if (syncStatus === PJQ.constants.integrations.erp.syncStatuses.REVIEWING
                    || syncStatus === PJQ.constants.integrations.erp.syncStatuses.APPROVED
                    || syncStatus === PJQ.constants.integrations.erp.syncStatuses.SYNCED
                ) {
                    this.options.canEdit = false;
                    this.options.canEditLineItems = false;
                    this.options.canDelete = false;
                    this.options.canEditStatus = false;
                }
            }
        }
    },
    renderData: function () {
        return {
            isFetched: this.isFetched,
            model: this.model,
            canEdit: this.options.canEdit,
            isAdmin: this.options.isAdmin,
            canDelete: this.options.canDelete,
            erpIntegration: this.erpIntegration,
            activeView: this.options.activeView,
            views: this.views,
            checkFieldVisible: _.bind(this.checkFieldVisible, this),
            checkFieldRequired: _.bind(this.checkFieldRequired, this)
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.activateView(this.options.activeView);

        this.stopListening(this.model);
        this.listenTo(this.model, 'change:statusId', () => {
            this.renderERP();
        });
        this.stopListening(this.model.lineItems);
        this.listenTo(this.model.lineItems, 'update', () => {
            this.renderERP();
        });
        this.renderERP();

        this.renderGeneral();
        this.renderLineItems();
        this.updateCounts();
        this.renderTotals();
    },
    updateCounts: function () {
        // todo: fix this to account for deleted items on an existing model
        this.$('.count-line-items').text(_.size(this.model.lineItems.models));
    },
    views: {
        GENERAL: 'D_General',
        LINEITEMS: 'D_LineItems'
    },
    activeViewChanged: function (e) {
        let view = e.target.hash ? e.target.hash.replace('#', '') : null;
        this.activateView(view);
    },
    activateView: function (view) {
        switch (view) {
            case this.views.LINEITEMS:
                // do nothing
                break;
            default:
                view = this.views.GENERAL;
                break;
        }
        this.$('.nav-link[href="#' + view + '"]').tab('show');
        this.options.activeView = view;
    },
    renderGeneral: function () {
        new PJQ.Binder(this.$el, this.model, {
            canEdit: !this.options.canEdit ? false : null,
            useDecimalPercentFields: true,
            watchElements: [
                'input',
                'textarea'
            ]
        });

        if (this.checkFieldVisible('type')) {
            this.typeSelectPicker = new PJQ.inputs.Selectpicker({
                el: this.$('.direct-cost-type'),
                isIntChoices: true,
                canEdit: this.options.canEdit,
                defaultValue: this.model.get('type'),
                onHide: _.bind(function () {
                    this.model.set('type', this.typeSelectPicker.getValue());
                }, this)
            });
        }

        this.statusPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-status'),
            isIntChoices: true,
            canEdit: this.options.canEditStatus,
            defaultValue: this.model.get('statusId'),
            choices: _.map(PJQ.constants.directcosts.directCostStatus, (st) => {
                return {
                    id: st,
                    name: PJQ.constants.directcosts.directCostStatusNames[st],
                    disabled: this.options.disabledStatuses != null && this.options.disabledStatuses.indexOf(st) > -1
                }
            }),
            onChange: (newStatus) => {
                let oldStatus = this.model.get('statusId');
                if(newStatus === oldStatus){
                    return;
                }

                this.model.set('statusId', newStatus);
                if (!this.model.isNew()) {
                    this.save((success) => {
                        if (success) {
                            PJQ.notifications.notify.successNotify({
                                message: 'Direct Cost saved successfully'
                            });
                        } else {
                            this.model.set('statusId', oldStatus);
                            this.statusPicker.setValue(oldStatus);
                        }
                    });
                } else{
                    this.render();
                }
            }
        });

        if (this.checkFieldVisible('vendor')) {
            this.vendorPicker = new PJQ.views.contacts.ContactsSelectInput({
                el: this.$('.vendor'),
                selectedContact: this.model.vendor,
                hideUsers: true,
                canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
                canEdit: this.options.isAdmin && !this.model.isERPSynced(),
                displayContactsBlock: true,
                context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
                isSingleChoice: true,
                onChange: _.bind(function (selectedContact) {
                    this.model.vendor = selectedContact;
                    this.model.set('vendorId', selectedContact ? selectedContact.get('contactId') : null);
                }, this)
            });
        }

        if (this.checkFieldVisible('reportedBy')) {
            this.reportedByPicker = new PJQ.views.contacts.ContactsSelectInput({
                el: this.$('.reported-by'),
                selectedContact: this.model.reportedBy,
                hideUsers: true,
                canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
                canEdit: this.options.isAdmin,
                displayContactsBlock: true,
                context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
                isSingleChoice: true,
                onChange: _.bind(function (selectedContact) {
                    this.model.reportedBy = selectedContact;
                    this.model.set('reportedById', selectedContact ? selectedContact.id : null);
                }, this)
            });
        }

        if (this.checkFieldVisible('appliedOn')) {
            new PJQ.inputs.Datepicker({
                el: this.$('.applied-on'),
                canEdit: this.options.canEdit,
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    defaultDate: this.model.get('appliedOn') != null ? PJQ.helpers.dateHelpers.parseDateString(this.model.get('appliedOn'), false) : null
                },
                onChange: _.bind(function (newDate) {
                    this.model.set('appliedOn', newDate);
                }, this)
            });
        }

        if (this.checkFieldVisible('receivedOn')) {
            new PJQ.inputs.Datepicker({
                el: this.$('.received-on'),
                canEdit: this.options.canEdit,
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    defaultDate: this.model.get('receivedOn') != null ? PJQ.helpers.dateHelpers.parseDateString(this.model.get('receivedOn'), false) : null
                },
                onChange: _.bind(function (newDate) {
                    this.model.set('receivedOn', newDate);
                }, this)
            });
        }

        if (this.checkFieldVisible('paidOn')) {
            new PJQ.inputs.Datepicker({
                el: this.$('.paid-on'),
                canEdit: this.options.canEdit,
                datepickerOptions: {
                    format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                    defaultDate: this.model.get('paidOn') != null ? PJQ.helpers.dateHelpers.parseDateString(this.model.get('paidOn'), false) : null
                },
                onChange: _.bind(function (newDate) {
                    this.model.set('paidOn', newDate);
                }, this)
            });
        }

        if (_.size(this.customFields) > 0) {
            this.directCostCustomFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
                el: this.$('.direct-cost-custom-fields'),
                isAdmin: true,
                isEdit: this.options.canEdit,
                collection: this.customFields,
                fieldValues: this.model.get('customFieldValues'),
                onChange: _.bind(function () {
                    this.model.isDirty = true;
                }, this)
            });
        }

        if (this.checkFieldVisible('attachments')) {
            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.direct-cost-file-uploader'),
                collection: this.model.attachments,
                canUpload: this.options.canEdit,
                useApiV2: true,
                canView: false,
                canDelete: this.options.isAdmin,
                includeProjectAttachments: false,
                previewImageDimension: 150,
                onSuccess: _.bind(function (file) {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.get('id') > 0) {
                        attachment.set('delete', true);
                    } else {
                        attachment.destroy();
                    }

                    this.model.isDirty = true;
                    callback();
                }, this)
            });
        }
    },
    renderLineItems() {
        if(this.lineItemsView){
            this.lineItemsView.remove();
        }

        this.lineItemsView = new PJQ.views.budget.LineItemsView({
            el: this.$('.direct-cost-line-items'),
            collection: this.model.lineItems,
            lineItemModel: PJQ.models.directcosts.LineItem,
            accountingMethod: this.model.get('accountingMethod'),
            canEdit: this.options.canEdit,
            canDelete: this.options.canEdit,
            canChangeAccountingMethod: true,
            showGrandTotal: true,
            onAccountingMethodChanged: _.bind(function (value) {
                this.model.set('accountingMethod', value);
            }, this),
            onLineItemChange: _.bind(function () {
                this.model.isDirty = true;
            }, this),
            onLineItemAdd: _.bind(function () {
                this.updateCounts();
            }, this),
            onLineItemDelete: _.bind(function () {
                this.updateCounts();
            }, this)
        });
    },
    renderTotals: function () {
        let amount = 0,
            billed = 0;
        _.each(this.model.lineItems.models, function (lineItem) {
            amount += lineItem.get('amount');
            billed += lineItem.get('billedToDate');
        });
        this.$('.total-amount').text(PJQ.helpers.formatHelpers.formatCurrency(amount));
        this.$('.total-billed').text(PJQ.helpers.formatHelpers.formatCurrency(billed));
        this.$('.total-remaining').text(PJQ.helpers.formatHelpers.formatCurrency(amount - billed));
    },
    saveEmail: function () {
        this.save((success) => {
            if (success) {
                PJQ.notifications.notify.successNotify({
                    message: 'Direct Cost saved successfully'
                });

                this.email();
            }
        });
    },
    checkFieldVisible: function (fieldName) {
        if (this.coreFieldSettings) {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isVisible');
            }
        }
        return true;
    },
    checkFieldRequired: function (fieldName) {
        if (this.coreFieldSettings) {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isRequired');
            }
        }
        return false;
    },
    saveDirectCost: function () {
        this.save((success) => {
            if (success) {
                PJQ.notifications.notify.successNotify({
                    message: 'Direct Cost saved successfully'
                });

                this.removeModal();
            }
        });
    },
    validate: function () {
        let isValid = true;

        if (this.directCostCustomFieldsForm != null && !this.directCostCustomFieldsForm.validate()) {
            isValid = false;
        }

        if (this.checkFieldRequired('vendor')) {
            if (!this.vendorPicker.validate()) {
                isValid = false;
            }
        }

        if (this.checkFieldRequired('reportedBy')) {
            if (!this.reportedByPicker.validate()) {
                isValid = false;
            }
        }

        if (this.checkFieldRequired('appliedOn')) {
            let $appliedOn = this.$('.applied-on');
            PJQ.helpers.inputHelpers.setInputError($appliedOn, true);
            if (this.model.get('appliedOn') == null || this.model.get('appliedOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($appliedOn, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('receivedOn')) {
            let $receivedOn = this.$('.received-on');
            PJQ.helpers.inputHelpers.setInputError($receivedOn, true);
            if (this.model.get('receivedOn') == null || this.model.get('receivedOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($receivedOn, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('paidOn')) {
            let $paidOn = this.$('.paid-on');
            PJQ.helpers.inputHelpers.setInputError($paidOn, true);
            if (this.model.get('paidOn') == null || this.model.get('paidOn').length === 0) {
                PJQ.helpers.inputHelpers.setInputError($paidOn, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('terms')) {
            let $terms = this.$('.terms');
            PJQ.helpers.inputHelpers.setInputError($terms, true);
            if (_.size(this.model.get('terms')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($terms, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('description')) {
            let $description = this.$('.description');
            PJQ.helpers.inputHelpers.setInputError($description, true);
            if (_.size(this.model.get('description')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($description, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('type')) {
            let $type = this.$('.direct-cost-type');
            PJQ.helpers.inputHelpers.setInputError($type, true);
            if (this.model.get('type') == null) {
                PJQ.helpers.inputHelpers.setInputError($type, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('attachments')) {
            this.fileUploader.clearError();
            let hasValidAttachment = _.find(this.model.attachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.fileUploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (!isValid && this.options.activeView !== 'general') {
            this.activateView(this.views.GENERAL);
            return isValid;
        }

        if (!this.lineItemsView.validate()) {
            isValid = false;

            this.activateView(this.views.LINEITEMS);
            return isValid
        }

        return isValid;
    },
    save: function (callback) {
        if (!this.validate()) {
            this.$('.modal').prevObject.scrollTop(0);
            if (typeof callback === 'function') {
                callback(false);
            }
            return;
        }

        this.model.save({
            lineItems: this.model.lineItems.models,
            customFields: this.directCostCustomFieldsForm != null ? this.directCostCustomFieldsForm.getChanged() : null
        }, {
            success: _.bind(function () {
                this.render();
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                this.options.project.trigger('directCostChanged', this.model);
                if (typeof callback === 'function') {
                    callback(true);
                }
            }, this),
            error: () => {
                if (typeof callback === 'function') {
                    callback(false);
                }
                PJQ.notifications.notify.errorNotify({
                    message: "Encountered an error while saving this Direct Cost. Please contact customer service."
                });
            }
        });
    },
    deleteDirectCost: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this direct cost?",
            onDelete: _.bind(function () {
                this.model.destroy({
                    success: _.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Direct cost deleted successfully'
                        });

                        if (typeof this.options.onDelete === 'function')
                            this.options.onDelete();

                        this.removeModal();
                    }, this)
                });
            }, this)
        });
    },
    email: function () {
        let projectName = this.options.project?.get('projectName')?.trim();
        let subject = `A Direct Cost has been shared with you ${projectName && _.size(projectName) > 0 ? `for ${projectName}` : ''}`;
        new PJQ.views.email.ComposeEmailModal({
            header: "Email Direct Cost",
            project: PJQ.app.session.project,
            subject: subject,
            onSave: _.bind(function (data) {
                this.model.share(data, _.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Direct Cost email sent'
                    });
                }, this));
            }, this)
        });
    },
    renderERP: function () {
        let $erp = this.$('.erp-sync');
        if (!this.options.isAdmin || this.erpIntegration == null || !this.options.project.isERPSynced()) {
            $erp.remove();
            return;
        }

        let canPush = true,
            disablePushReason = "";
        if (_.size(this.model.lineItems.models) === 0
            || this.model.get('statusId') !== PJQ.constants.directcosts.directCostStatus.APPROVED) {
            canPush = false;
            disablePushReason = "Direct Cost must be approved and have line items";
        }

        PJQ.helpers.erp.renderERPButtons($erp, {
            pushSupported: !this.model.isERPSynced() && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_DIRECT_COSTS),
            canPush: canPush,
            canPushChanges: false,
            disablePushReason: disablePushReason,
            unlinkSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.UNLINK_DIRECT_COSTS),
            status: this.model.erpSyncStatus()
        });
    },
    pushERP: function (callback) {
        if (!this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_DIRECT_COSTS)) {
            return;
        }

        this.save((success) => {
            if (success) {
                this.erpIntegration.pushDirectCost(this.model, () => {
                    PJQ.notifications.notify.successNotify({
                        message: 'Direct Cost pushed to ERP'
                    });

                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }

                    if (callback && typeof callback === 'function') {
                        callback();
                    } else {
                        this.render();
                    }
                });
            }
        });
    },
    undoPushERP: function () {
        if (this.model.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.REVIEWING) {
            this.erpIntegration.undoPush(this.model, _.bind(function () {
                PJQ.notifications.notify.successNotify({
                    message: 'Direct Cost removed from ERP approval'
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                this.render();
            }, this));
        }
    },
    unlinkERP: function () {
        if (this.erpIntegration != null) {
            let loader = new PJQ.Loader(this.$('.modal-content'));
            this.erpIntegration.unlinkDirectCost(this.model, _.bind(function (success) {
                if (success) {
                    loader.remove();
                    PJQ.notifications.notify.successNotify({
                        message: 'Direct Cost unlinked from ERP'
                    });

                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }

                    this.render();
                }
            }, this));
        }
    },
    exportDirectCost: function () {
        let callback = _.bind(function () {
            PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.model.get('projectId')
                },
                {
                    endpoint: 'directcosts',
                    value: this.model.get('id')
                },
                {
                    endpoint: 'export',
                }
            ]), {isAPIv2: true});
        }, this);

        if (this.options.canEdit && this.model.hasChanged()) {
            this.save(callback);
        } else {
            callback();
        }
    },
    close: function () {
        if (this.model.hasChanged() && this.options.canEdit) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.saveDirectCost();
                    this.removeModal();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});

PJQ.views.directcosts.DirectCostSettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DIRECTCOSTS, 'modal-direct-cost-settings'),
        minWidth: '600px',
    },
    events: {
        'change .select-column': 'columnSelected',
        'click .btn-edit-company-default': 'editCompanySettings',
        'click button.settings-save': 'onSave'
    },
    beforeModalCreated: function () {
        this.userSettings = this.options.directCostView.userSettings;
    },
    beforeRender: function () {
        // copy userSettings for our UI; we only update global userSettings object on save.
        this.options.userSettings = [];

        this.options.defaultTypeFilter = this.userSettings.get('defaultTypeFilter');
        this.options.defaultStatusFilter = this.userSettings.get('defaultStatusFilter');
        _.each(this.userSettings.attributes.viewSettings, _.bind(function (setting) {
            let columns = this.options.directCostView.getDataTableInstance(setting.view).getColumns(true),
                selectedColumns = (_.size(setting.columns) > 0) ? setting.columns : setting.columnsDefault;
            _.each(columns, _.bind(function (column) {
                column.visible = selectedColumns.indexOf(column.columnData) !== -1
            }, this));

            this.options.userSettings.push({
                view: setting.view,
                rowsPerPage: setting.rowsPerPage,
                columns: columns
            });
        }, this));
    },
    renderData: function () {
        return {
            userSettings: this.userSettings
        }
    },
    afterRender: function () {
        let defaultFilter = {};
        defaultFilter[PJQ.constants.directcosts.filterType.DIRECT_COST_TYPE_FILTER] = this.userSettings.get('defaultTypeFilter');
        defaultFilter[PJQ.constants.directcosts.filterType.DIRECT_COST_TYPE_FILTER] = _.map(defaultFilter[PJQ.constants.directcosts.filterType.DIRECT_COST_TYPE_FILTER], function (type) {
            return type * -1;
        });
        defaultFilter[PJQ.constants.directcosts.filterType.DIRECT_COST_STATUS_FILTER] = this.userSettings.get('defaultStatusFilter');

        this.defaultFilterSelectPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-filter-default'),
            isIntChoices: true,
            isMultiple: true,
            isGrouped: true,
            mustSelectValuePerOptGroup: false,
            defaultValue: defaultFilter,
            onHide: _.bind(function () {
                this.options.defaultTypeFilter = this.defaultFilterSelectPicker.getValue()[PJQ.constants.directcosts.filterType.DIRECT_COST_TYPE_FILTER];
                this.options.defaultTypeFilter = _.map(this.options.defaultTypeFilter, function (type) {
                    return type * -1;
                });

                this.options.defaultStatusFilter = this.defaultFilterSelectPicker.getValue()[PJQ.constants.directcosts.filterType.DIRECT_COST_STATUS_FILTER];
            }, this)
        });

        this.rowsPerPage = new PJQ.inputs.Selectpicker({
            el: this.$('select.rows-per-page'),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.currentView.rowsPerPage = value;
            }, this)
        });

        this.selectView(PJQ.constants.directcosts.view.DIRECT_COSTS);
    },
    editCompanySettings: function () {
        this.userSettings = new PJQ.models.directcosts.UserSettings(null, {
            forCompany: true
        });
        this.userSettings.fetch({
            success: _.bind(function () {
                this.render();
            }, this)
        });
    },
    selectView: function (view) {
        this.currentView = _.find(this.options.userSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));

        if (view.indexOf('-') === -1) {
            this.rowsPerPage.setValue(this.currentView.rowsPerPage);
            this.$('div.rows-per-page').show();
        } else
            this.$('div.rows-per-page').hide();

        if (this.dataTable) {
            this.dataTable.undelegateEvents();
            $(this.dataTable.el).empty();
        }

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('div.select-columns-datatable'),
            data: this.currentView.columns,
            isHideSearch: true,
            pageLength: 6,
            order: [],
            columns: [
                {"data": "title", "title": "Column", "orderable": false},
                {
                    "data": "visible",
                    "title": "Show",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data) {
                        return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (data ? ' checked ' : '') + 'class="select-column"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                    }, this),
                    "width": '10%'
                }
            ],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });

    },
    columnSelected: function (sender) {
        this.dataTable.dataTable.row($(sender.currentTarget).closest('tr')).data().visible = $(sender.currentTarget).prop('checked');
    },
    onSave: function () {

        let fnOnSave = _.bind(function () {
            if (typeof this.options.onSave === 'function')
                this.options.onSave();
            this.removeModal();
        }, this);

        this.userSettings.set('defaultTypeFilter', this.options.defaultTypeFilter);
        this.userSettings.set('defaultStatusFilter', this.options.defaultStatusFilter);

        _.each(this.options.userSettings, _.bind(function (settingTemp) {
            _.each(this.userSettings.get('viewSettings'), _.bind(function (setting) {
                if (settingTemp.view === setting.view) {
                    setting.rowsPerPage = settingTemp.rowsPerPage;

                    let columns = _.size(setting.columns) > 0 ? setting.columns.slice() : setting.columnsDefault.slice();

                    // update columns
                    _.each(settingTemp.columns, _.bind(function (column) {
                        if (column.visible) {
                            if (columns.indexOf(column.columnData) === -1)
                                columns.push(column.columnData);
                        } else {
                            if (columns.indexOf(column.columnData) !== -1)
                                columns = _.filter(columns, _.bind(function (columnTemp) {
                                    return columnTemp != column.columnData;
                                }, this));
                        }
                    }, this));

                    setting.columns = columns;
                }
            }, this));
        }, this));

        this.userSettings.save(null, {
            success: _.bind(function () {
                fnOnSave();
            }, this)
        });
    }
});

PJQ.views.directcosts.ProjectDirectCosts = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DIRECTCOSTS, 'direct-costs-list'),
        directCostId: null
    },
    events: {
        'click .btn-pull-erp': 'pullERP',
        'click .btn-settings': 'editSettings',
        'click .new-direct-cost': 'newDirectCost',
        'click .btn-view-direct-cost': 'viewDirectCostClicked',
        'click .btn-delete-direct-cost': 'deleteDirectCostClicked',
        'click .btn-export': 'exportList'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.collection == null) {
            this.collection = new PJQ.collections.directcosts.DirectCosts(null, {
                projectId: this.options.project.get('projectId'),
                costCodeId: this.options.costCodeId ? this.options.costCodeId : null,
                costTypeId: this.options.costTypeId ? this.options.costTypeId : null
            });
        }

        if (!this.collection.isFetched) {
            await this.collection.fetch();
        }

        this.settings = await PJQ.app.session.fetchDirectCostSettings();
        this.userSettings = await PJQ.app.session.fetchDirectCostUserSettings();
        this.customFields = await this.options.project.fetchDirectCostCustomFields();
        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
            await this.options.project.fetchERPObject();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.canAdd = PJQ.app.session.project.hasPermission('directCosts.canAdd');
        this.options.canEdit = PJQ.app.session.project.hasPermission('directCosts.canEdit');
        this.options.isAdmin = PJQ.app.session.project.hasPermission('directCosts.isAdmin');
    },
    renderData: function () {
        return {
            isFetched: this.isFetched,
            canAdd: this.options.canAdd,
            isAdmin: this.options.isAdmin,
            erpIntegration: this.erpIntegration
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.renderView();

        if (this.options.directCostId > 0) {
            let initDirectCost = this.collection.get(this.options.directCostId);
            if (initDirectCost != null) {
                this.viewDirectCost(initDirectCost);
                this.options.directCostId = null;
            }
        }
    },
    renderStats: function () {
        let totals = this.collection.getTotalAmountsByStatus();
        this.$('.total-draft').text(PJQ.helpers.formatHelpers.formatCurrency(totals[PJQ.constants.directcosts.directCostStatus.DRAFT]));
        this.$('.total-pending').text(PJQ.helpers.formatHelpers.formatCurrency(totals[PJQ.constants.directcosts.directCostStatus.PENDING]));
        this.$('.total-approved').text(PJQ.helpers.formatHelpers.formatCurrency(totals[PJQ.constants.directcosts.directCostStatus.APPROVED]));
        this.$('.total-revise').text(PJQ.helpers.formatHelpers.formatCurrency(totals[PJQ.constants.directcosts.directCostStatus.REVISE]));
    },
    renderERPButton: function () {
        let $erp = this.$('.erp-sync');
        if (!this.options.isAdmin || this.erpIntegration == null || this.erpIntegration.getSetting(PJQ.constants.integrations.settings.SYNC_DIRECT_COSTS) === false || !this.options.project || !this.options.project.isERPSynced()) {
            $erp.remove();
            return;
        }

        let pullSupported = this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_DIRECT_COSTS);
        PJQ.helpers.erp.renderERPButtons($erp, {
            pushSupported: false,
            pullSupported: pullSupported,
            canPull: true
        });
    },
    pullERP: function () {
        if (this.options.project != null && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_DIRECT_COSTS)) {
            this.erpIntegration.pullDirectCosts(this.options.project, (res, err) => {
                if (res == null) {
                    return;
                }

                PJQ.notifications.notify.successNotify({
                    message: 'Direct cost transactions pulled from ERP'
                });
                this.directCosts = res;

                this.collection.fetch({
                    success: () => {
                        this.render();
                    }
                });
            });
        }
    },
    getFilterValues: function () {
        let directCostTypes = this.filterSelectPicker.getValue()[PJQ.constants.directcosts.filterType.DIRECT_COST_TYPE_FILTER];
        directCostTypes = _.map(directCostTypes, function (type) {
            return type * -1;
        });
        return {
            projectId: this.options.project.get('projectId'),
            search: this.$('.input-search').val(),
            typeFilter: directCostTypes.join(','),
            statusFilter: this.filterSelectPicker.getValue()[PJQ.constants.directcosts.filterType.DIRECT_COST_STATUS_FILTER].join(',')
        };
    },
    renderView: function () {
        if (this.dataTable) {
            this.dataTable.remove();
            this.dataTable = null;
        }

        this.dataTable = this.getDataTableInstance();
        this.renderStats();
    },
    getDataTableInstance: function () {
        return new PJQ.views.directcosts.DirectCostDataTable({
            el: this.$('.direct-cost-data'),
            rowId: "cid",
            data: this.collection.models,
            onPageSizeChange: function (value) {
                // PJQ.helpers.cookieHelpers.setCookie(PJQ.constants.cookies.RFI_PAGE_LENGTH, value);
            },
            isAdmin: this.options.isAdmin,
            statusIds: this.options.statusIds,
            headerData: _.bind(function () {
                return {
                    project: this.options.project,
                    canAdd: this.options.canAdd,
                    isAdmin: this.options.isAdmin
                };
            }, this),
            directCostView: this,
            customFields: this.customFields,
            userSettings: this.userSettings,
            settings: this.userSettings.getSettings(PJQ.constants.directcosts.view.DIRECT_COSTS),
            order: [[1, 'asc']],
            colReorder: {
                fixedColumnsLeft: 1,
                fixedColumnsRight: 1,
                realtime: false
            },
            columnOrderChanged: _.bind(function () {
                this.userSettings.save();
            }, this),
            onRowDoubleClick: _.bind(function (row) {
                this.viewDirectCost(row.data());
            }, this),
            afterDataTableRender: _.bind(function () {
                this.renderERPButton();
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewDirectCost(row.data());
                        }, this)
                    }
                ]
            }
        });
    },
    editSettings: function () {
        new PJQ.views.directcosts.DirectCostSettingsModal({
            directCostView: this,
            onSave: _.bind(function () {
                this.renderView();
                PJQ.notifications.notify.successNotify({
                    message: 'Settings updated successfully'
                });
            }, this)
        });
    },
    newDirectCost: function (e) {
        this.viewDirectCost();
    },
    viewDirectCostClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.viewDirectCost(row.data());
    },
    viewDirectCost: function (directCost) {
        let isNew = directCost == null;
        new PJQ.views.directcosts.DirectCostEditModal({
            model: directCost,
            settings: this.settings,
            customFields: this.customFields,
            onSave: _.bind(function (directCost) {
                if (isNew) {
                    this.collection.add(directCost);
                }
                this.renderView();
            }, this),
            onDelete: _.bind(function (directCost) {
                this.collection.remove(directCost);
                this.renderView();
            }, this)
        });
    },
    deleteDirectCostClicked: function (e) {
        let row = this.dataTable.getRow($(e.currentTarget).closest('tr'));
        this.deleteDirectCost(row);
    },
    deleteDirectCost: function (row) {
        if (row != null) {
            let directCost = row.data();
            if (directCost != null) {
                new PJQ.views.modals.DeleteCancel({
                    header: "Delete Direct Cost",
                    body: "Are you sure you want to delete this Direct Cost?",
                    onDelete: _.bind(function () {
                        directCost.destroy({
                            success: _.bind(function () {
                                this.dataTable.removeRow(row);
                                if (typeof this.options.onDelete === 'function') {
                                    this.options.onDelete(directCost);
                                }
                            }, this)
                        });
                    }, this)
                });
            }
        }
    },
    exportList: function () {
        let filter = this.dataTable.getFilterValues(),
            parameters = [
                {
                    parameter: 'search',
                    value: filter.search
                },
                {
                    parameter: 'typeFilter',
                    value: filter.typeFilter
                },
                {
                    parameter: 'statusFilter',
                    value: filter.statusFilter
                },
                {
                    parameter: 'timeZoneOffset',
                    value: new Date().getTimezoneOffset()
                }
            ];

        PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: PJQ.app.session.project.id
            },
            {
                endpoint: 'directcosts'
            },
            {
                endpoint: 'export'
            }
        ], parameters), {isAPIv2: true});
    },
    renderTotals: function (draft, total) {
        this.$('.total-draft').text(PJQ.helpers.formatHelpers.formatCurrency(draft));
        this.$('.total-direct-costs').text(PJQ.helpers.formatHelpers.formatCurrency(total));
    }
});

PJQ.views.directcosts.ModalViewDirectCosts = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.DIRECTCOSTS, 'modal-view-direct-costs'),
        maxWidth: 1000,
        isShowCloseButton: true,
        onSave: _.noop,
        isAdmin: true
    },
    events: {},
    beforeModalCreated: function () {

    },
    renderData: function () {
        return {
            model: this.model
        }
    },
    afterRender: function () {
        if (this.model != null) {
            new PJQ.views.directcosts.ProjectDirectCosts({
                el: this.$('.modal-body'),
                model: this.model,
                costCodeId: this.model.get('costCodeId'),
                costTypeId: this.model.get('costTypeId'),
                statusIds: this.options.statusIds,
                project: this.options.project
            })
        }
    },
});
PJQ.models.directcosts.DirectCost = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        if (this.isNew()) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.get('projectId')
                },
                {
                    endpoint: 'directcosts'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'directcosts',
                value: this.get('id')
            }
        ]);
    },
    parse: function (model) {
        if (!model)
            return model;

        this.attachments = new PJQ.collections.directcosts.Attachments(model.attachments);
        this.lineItems = new PJQ.collections.directcosts.LineItems(model.lineItems);

        if (model && model.vendor)
            this.vendor = new PJQ.models.contacts.Contact(model.vendor);

        if (model && model.reportedBy)
            this.reportedBy = new PJQ.models.contacts.Contact(model.reportedBy);

        return model;
    },
    beforeSave: function () {
        this.set('attachments', this.attachments.toJSON());
        this.set('lineItems', this.lineItems.toJSON());
    },
    syncERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/syncerp',
            isAPIv2: true,
        }).post().done(_.bind(function (response) {
            callback();
        }, this)).fail(_.bind(function (xhr, err, result) {
            //todo: error
        }, this));
    },
    unlinkERP: function (callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/unlinkerp',
            isAPIv2: true,
        }).post().done(_.bind(function () {
            this.set('externalId', null);
            if (typeof callback === 'function') {
                callback(true);
            }
        }, this)).fail(_.bind(function (xhr) {
            if (typeof callback === 'function') {
                let err;
                if (xhr.responseJSON != null) {
                    err = xhr.responseJSON.type;
                } else {
                    err = null;
                }
                callback(false, err);
            }
        }, this));
    },
    makeERPUrl: function (integration) {
        let externalId = this.externalId();
        if (_.size(externalId) === 0) {
            return '';
        }

        switch (integration.get('name')) {
            case PJQ.constants.integrations.providers.QBO.name:
                return '';
            default:
                return '';
        }
    },
    share: function (data, callback) {
        new PJQ.ajax.Request({
            endpoint: this.endpoint() + '/email',
            isAPIv2: true,
            data: {
                subject: data != null ? data.subject : null,
                body: data != null ? data.body : null,
                toEmails: data != null ? data.toEmails : null,
                ccEmails: data != null ? data.ccEmails : null,
            }
        }).post().done(_.bind(function (response) {
            callback();
        }, this)).fail(_.bind(function (xhr, err, result) {
            //todo: error
        }, this));
    }
});

PJQ.models.directcosts.LineItem = PJQ.models.budget.BaseLineItem.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    parse: function (model) {
        if (!model)
            return model;

        if (model && model.group) {
            this.group = new PJQ.models.groups.Group(model.group);
        } else
            this.group = null;

        return model;
    }
});

PJQ.models.directcosts.Attachment = PJQ.models.files.File.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id'
});

PJQ.models.directcosts.CustomField = PJQ.models.customFields.CustomField.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'directcosts'
            },
            {
                endpoint: 'customfields',
                value: this.get('id')
            }
        ]);
    }
});

PJQ.models.directcosts.CustomFieldChoice = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'directcosts'
            },
            {
                endpoint: 'customfields',
                value: this.get('customFieldId')
            },
            {
                endpoint: 'choices',
                value: this.get('id')
            }
        ]);
    }
});

PJQ.models.directcosts.DirectCostFieldSetting = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'fields',
                value: this.id ? this.id : 'directcosts'
            }
        ]);
    }
});


PJQ.models.directcosts.Settings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'directcosts'
            },
            {
                endpoint: 'settings'
            }
        ]);
    }
});

PJQ.models.directcosts.UserSettings = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'settingId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'directcosts'
            },
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'user'
            }
        ]);
    },
    getSettings: function (view) {
        return _.find(this.attributes.viewSettings, _.bind(function (setting) {
            return setting.view === view;
        }, this));
    }
});

PJQ.collections.directcosts.DirectCosts = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.directcosts.DirectCost,
    endpoint: function () {
        let params = [
            {
                parameter: 'search',
                value: this.options.search
            },
            {
                parameter: 'typeFilter',
                value: this.options.typeFilter
            },
            {
                parameter: 'statusFilter',
                value: this.options.statusFilter
            }
        ];
        if (this.options.costCodeId && this.options.costTypeId) {
            params.push({
                parameter: 'costCodeId',
                value: this.options.costCodeId
            }, {
                parameter: 'costTypeId',
                value: this.options.costTypeId
            });
        }
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'directcosts'
            }
        ], params);
    },
    getTotalAmountsByStatus: function () {
        let result = {};
        result[PJQ.constants.directcosts.directCostStatus.DRAFT] = 0;
        result[PJQ.constants.directcosts.directCostStatus.PENDING] = 0;
        result[PJQ.constants.directcosts.directCostStatus.APPROVED] = 0;
        result[PJQ.constants.directcosts.directCostStatus.REVISE] = 0;
        _.each(this.models, function (directCost) {
            result[directCost.get('statusId')] += directCost.get('amount');
        });
        return result;
    }
});

PJQ.collections.directcosts.LineItems = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.directcosts.LineItem,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
                value: this.options.projectId
            },
            {
                endpoint: 'directcosts',
                value: this.options.directCostId
            },
            {
                endpoint: 'lineitems'
            }
        ]);
    }
});

PJQ.collections.directcosts.Attachments = PJQ.collections.files.Files.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.directcosts.Attachment,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'commitments',
                value: this.options.commitmentId
            },
            {
                endpoint: 'attachments'
            }
        ]);
    }
});

PJQ.collections.directcosts.CustomFields = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.directcosts.CustomField,
    endpoint: function () {
        if (this.options.projectId > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.projectId
                },
                {
                    endpoint: 'directcosts'
                },
                {
                    endpoint: 'customfields'
                }
            ]);
        }

        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'directcosts'
            },
            {
                endpoint: 'customfields'
            }
        ]);
    }
});

PJQ.collections.directcosts.CustomFieldChoices = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.directcosts.CustomFieldChoice
});

PJQ.collections.directcosts.DirectCostFieldSettings = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.directcosts.DirectCostFieldSetting,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'settings'
            },
            {
                endpoint: 'fields',
                value: 'directcosts'
            }
        ]);
    }
});